module.exports = __webpack_public_path__ + "static/img/jszg_img_xxlc_content.abd7634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jszg_img_xxlc_content.png
// module id = 9XLr
// module chunks = 0